import {
  FOC_TOUR_LABEL_PLN_DEMOB,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_PLN_DEMOB_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlnTourPopoverHtml,
  requirement,
  type FocPlnTourStepDef,
} from './focPlnTourTypes';

export const FOC_PLN_DEMOB_TOUR_PARAM = 'focPlnDemobTour';
export const FOC_PLN_DEMOB_TOUR_HREF = HREF;
export { focPlnTourPopoverHtml };

export const FOC_PLN_DEMOB_TOUR_STEPS: FocPlnTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'demob-workspace',
    title: FOC_TOUR_LABEL_PLN_DEMOB,
    description:
      'The Demobilization Unit workspace supports Demobilization Plan development, resource-release planning, release priorities/status, check-out requirements, travel/support coordination, equipment return, documentation completion, and ICS 221-CG or other applicable demobilization products.',
  },
  requirement({
    id: 'pln005',
    requirementId: 'FOC-PLN-005',
    name: 'Demobilization Unit Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'demob-workspace',
    description:
      'PRATUS provides a Demobilization Unit workspace supporting Demobilization Plan development, resource-release planning, release priorities, release status, check-out requirements, travel/support coordination, equipment return, documentation completion, and ICS 221-CG or other applicable demobilization products.',
    bullets: [
      'FOC-PLN-005a — Demobilization Unit Task View: one operational view of tentative releases, approvals, check-out actions, travel/transport, ICS 221 status, performance-evaluation status, equipment/property return, financial closeout dependencies, release time, home-unit return status, and unresolved actions.',
      'FOC-PLN-005b — Demobilization Dependency Visibility: which release prerequisites are complete, outstanding, waived, or N/A; can flag incomplete items without hard-stopping release unless Coast Guard policy requires it.',
      'FOC-PLN-005c — Demobilization and Documentation Coordination: status visible to Resources, Documentation, Operations, Logistics, Finance/Admin, Command, and external-partner coordinators per permission; sensitive personnel evaluation content remains restricted.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLN_DEMOB),
  },
];
